import { of } from 'rxjs';

var MockHttpResponseData = /** @class */ (function () {
    function MockHttpResponseData(_a) {
        var _b = (_a === void 0 ? {} : _a).data, data = _b === void 0 ? null : _b;
        this.data = null;
        this.status = 0;
        this.statusText = '';
        this.headers = new Headers();
        this.data = data;
    }
    return MockHttpResponseData;
}());
/**
 * An empty http client implementation
 * To be mocked (Jest, Jasmine etc) by consumer
 */
var MockConnectHttpClient = /** @class */ (function () {
    function MockConnectHttpClient() {
    }
    MockConnectHttpClient.prototype.get = function (url, options) {
        return of();
    };
    MockConnectHttpClient.prototype.head = function (url, options) {
        return of();
    };
    MockConnectHttpClient.prototype.post = function (url, body, options) {
        return of();
    };
    MockConnectHttpClient.prototype.put = function (url, body, options) {
        return of();
    };
    MockConnectHttpClient.prototype.patch = function (url, body, options) {
        return of();
    };
    MockConnectHttpClient.prototype.delete = function (url, options) {
        return of();
    };
    return MockConnectHttpClient;
}());

export { MockConnectHttpClient, MockHttpResponseData };
